import { render, staticRenderFns } from "./tasks-dialog.vue?vue&type=template&id=5066f645&scoped=true&"
import script from "./tasks-dialog.vue?vue&type=script&lang=ts&"
export * from "./tasks-dialog.vue?vue&type=script&lang=ts&"
import style0 from "@/modules/Dashboard/styles/dashboard-dialog.scss?vue&type=style&index=0&id=5066f645&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5066f645",
  null
  
)

export default component.exports